export const createClaimAndLegalCostService =
  (fetch) => async (claimAndLegalCost) => {
    try {
      const formData = new FormData();
      formData.append("file", claimAndLegalCost.legalReport);
      for (let key in claimAndLegalCost) {
        if (key !== "legalReport") {
          formData.append(key, claimAndLegalCost[key]);
        }
      }

      const response = await fetch({
        url: "/api/v1/siniestros-viales/costos-siniestros-juridicos",
        method: "post",
        body: formData,
        contentType: "multipart/form-data",
      });

      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  };
